import { GiftCard } from "../types/giftCard";
import { get, post } from "./fetch.core";

async function listGiftCard({ userId }: { userId: string }) {
  return (await get<GiftCard[]>(`/pos/giftcard/list?userId=${userId}`)).data;
}

async function redeemAsReward(data: { userId: string; code: string }) {
  const res = await post<{ msg: string }>("/pos/giftcard/redeem", data);
  return res.data;
}

const giftCardCore = {
  listGiftCard,
  redeemAsReward,
};

export default giftCardCore;
